import React from 'react';
import moment from 'moment';
import cx from 'classnames';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useIsCustomScrollbar } from '@shared/hooks';
import { bytesToGB } from '@account-settings/utils';
import Field from './WorkspaceCardFooterField';
import { WorkspaceCardFooterProps } from './WorkspaceCardFooter.type';
import classes from './WorkspaceCardFooter.module.scss';

const WorkspaceCardFooter: React.FC<WorkspaceCardFooterProps> = ({
  createdAt,
  workspaceUrl,
  workspaceStorageUsage,
  projectsCount,
  createdBy
}) => {
  const createdTime = moment(createdAt).fromNow();
  const storageUsage = `${bytesToGB(workspaceStorageUsage)} GB`;

  const isCustomScrollbar = useIsCustomScrollbar();

  const shouldTextTruncate = useMediaQuery('(max-width:1080px)');

  return (
    <div className={classes.footerContainer}>
      <div
        className={cx(classes.fields, { customScrollbar: isCustomScrollbar })}
      >
        <Field
          label="Created"
          value={createdTime}
          shouldTextTruncate={shouldTextTruncate}
          dataMaskTest="a few seconds ago"
        />
        <Field label="Projects" value={projectsCount} isTruncatable={false} />
        <Field
          label="Storage usage"
          value={storageUsage}
          shouldTextTruncate={shouldTextTruncate}
        />
        <Field
          label="Created by"
          value={createdBy}
          shouldTextTruncate={shouldTextTruncate}
          dataMaskTest="username"
        />
        <Field
          label="URL"
          value={workspaceUrl}
          isMaxShrinkable
          shouldTextTruncate={shouldTextTruncate}
          dataMaskTest={`${window.location.origin}/username`}
        />
      </div>
    </div>
  );
};

export default WorkspaceCardFooter;
